import { Tabs } from '@chakra-ui/react'
import { Modal } from 'uikit'
import { QrRaForm } from './QrRaForm'
import { RbForm } from './RbForm'
import { RuForm } from './RuForm'

export const Registry = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onOpenChange={onClose} title="Отправка реестров">
      <Tabs.Root variant="subtle" size="sm" colorPalette="orange" defaultValue="ra">
        <Tabs.List mb="16px">
          <Tabs.Trigger value="ra">РА</Tabs.Trigger>
          <Tabs.Trigger value="rb">РБ</Tabs.Trigger>
          <Tabs.Trigger value="qr-ra">QR_РА</Tabs.Trigger>
        </Tabs.List>
        <Tabs.Content value="ra" pt={0} pb={0}>
          <RuForm />
        </Tabs.Content>
        <Tabs.Content value="rb" pt={0} pb={0}>
          <RbForm />
        </Tabs.Content>
        <Tabs.Content value="qr-ra" pt={0} pb={0}>
          <QrRaForm />
        </Tabs.Content>
      </Tabs.Root>
    </Modal>
  )
}
